import * as React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

export const TriangleArrow = (props: SvgProps) => (
  <Svg width='12' height='13' viewBox='0 0 12 13' {...props}>
    <Path d='M12 6.5L0.75 12.9952L0.75 0.00480938L12 6.5Z' fill='currentColor' />
  </Svg>
)
